import React from "react";
import { RatingItem } from "@/modules/performance/components/rating-item";
import { TextAreaItem } from "@/modules/performance/components/textarea-item";

export const SectionPanel = ({ control, section, disabled }) => {
  return (
    <div className="space-y-4">
      {section.items.map((it) => {
        if (it.type === "textarea") {
          return (
            <TextAreaItem
              key={it.key}
              control={control}
              name={it.key}
              disabled={disabled}
              label={it.label}
            />
          );
        }
        return (
          <RatingItem
            key={it.key}
            control={control}
            name={it.key}
            disabled={disabled}
            label={it.label}
            description={it.description}
          />
        );
      })}
    </div>
  );
};
